rwgps = window.rwgps || {};

rwgps.Router = function(opts) {
  this.opts = opts;
  if(opts) {
    switch(opts.type) {
      case "google":
        if (!window.rwgps.config.labs.always_graph_hopper) {
          return new rwgps.Router.Google(opts);
        } // otherwise fall through to rwgps routing below
      case "rwgps":
        return new rwgps.Router.RWGPSCombined(opts);
      case "arcgis":
        return new rwgps.Router.ArcGIS(opts);
    }
  }
}
rwgps.Router.euclideanDistance = function(a, b) {
  return Math.pow(Math.pow(a.lat - b.lat, 2) + Math.pow(a.lng - b.lng, 2), 0.5);
}
rwgps.Router.prototype = {
  cleanupNotes: function(notes) {
    //we want to toss out any directions that are duplicates or frivolous
    var divKill = /<div.*?>(.*?)<\/div>/gi;
    var bKill = /<\/?b>/gi;
    var orderKill = /take the (.*?) (right|left)/gi;
    var wbrKill = /<wbr\/>/g;
    notes = notes.replace(divKill, '').replace(bKill, '').replace(orderKill, 'Turn $2').replace(wbrKill, '\u200B');
    return notes;
  },
  extractTypeFromNotes: function(notes) {
    const tokens = notes.split(' ')
    let type = null

    for(let token of tokens) {
      //special case second regex is because gmaps doesn't space japenese characters, so can't split on space and use ^$ in regex.
      if(token.match(/^(left|venstre|vänster|vasemmalle|linksaf|links|αριστερά|izquierda|esquerda|gauche|sinistra|лево|налево|leve|levo|lewo|左)[\.,]?$/i) || token.match(/左/i)) {
        type = 'Left'
        break
      } else if(token.match(/^(right|høyre|højre|höger|oikealle|rechtsaf|rechts|δεξιά|derecha|direita|droite|destra|прво|направо|десно|desno|desne|prawo|右)[\.,]?$/i) || token.match(/右/i)) {
        type = 'Right'
        break
      }
    }
    if(type == null) type = "Straight"

    return type;
  },
  removeDuplicates: function(points) {
    var pts = [];
    for(var i = 0; i < points.length; i++) {
      var pt = points[i];
      var prev = points[i-1];
      if(prev && prev.point.lat == pt.point.lat && prev.point.lng == pt.point.lng) {
        continue;
      }
      pts.push(pt);
    }
    return pts;
  },
  decodePath: function(encoded) {
    // var start = new Date().getTime();
    var len = encoded.length;
    var index = 0;
    var array = [];
    var lat = 0;
    var lng = 0;
    var surface = 0;
    var rc = 0;
    var re = 0;

    while (index < len) {
      var b;
      var shift = 0;
      var result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var deltaLat = ((result & 1) ? ~(result >> 1) : (result >> 1));
      lat += deltaLat;

      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var deltaLon = ((result & 1) ? ~(result >> 1) : (result >> 1));
      lng += deltaLon;

      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var deltaSurface = ((result & 1) ? ~(result >> 1) : (result >> 1));
      surface += deltaSurface;

      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var deltaRC = ((result & 1) ? ~(result >> 1) : (result >> 1));
      rc += deltaRC;

      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var deltaRE = ((result & 1) ? ~(result >> 1) : (result >> 1));
      re += deltaRE;

      const pt = [lat * 1e-5, lng * 1e-5, surface * 1e-1, rc * 1e-1, re];

      array.push(pt);
    }
    // var end = new Date().getTime();
    //trace("decoded " + len + " coordinates in " + ((end - start) / 1000) + "s");
    return array;
  }
}

rwgps.Router.ArcGIS = function(opts) {
  this.opts = opts;
  this.routingUrl = opts.url;
  this.language = opts.language;
  this.token = opts.token;
  this.attributes = opts.attributes;
}
rwgps.Router.ArcGIS.prototype = new rwgps.Router();
rwgps.Router.ArcGIS.prototype.getDirections = function(points, opts, lineColor, success, error) {
  var features = [], self = this, impedance;
  var restrictions = "";
  var language = this.language || "en_US";
  for(var z = 0; z < points.length; z++) {
    features.push({
      geometry: { x: points[z].lng, y: points[z].lat, spatialReference: {wkid: 4326} }
    });
  }

  var r = opts.getEnabledRestrictions();
  for(var xxx = 0; xxx < r.length; xxx++) {
    var res = this.attributes[r[xxx]];
    if(res) {
      if(restrictions.length > 0 && restrictions[restrictions.length-1] != ',')
        restrictions += ",";
      restrictions += res;
    }
  }
  if(opts.walkingMode())
    impedance = this.opts.modes.walking.cost;
  else if(opts.cyclingMode())
    impedance = this.opts.modes.cycling.cost;
  else
    impedance = this.opts.modes.driving.cost;

  $.ajax({
    url: this.routingUrl + "/solve",
    data: {
      stops: JSON.stringify({type: "features", features: features}),
      returnRoutes: true,
      returnDirections: true,
      directionsLengthUnits: "esriNAUMeters",
      returnBarriers: false,
      returnStops: false,
      preserveFirstStop: false,
      preserveLastStop: false,
      outputGeometryPrecision: 3,
      outputGeometryPrecisionUnits: "esriMeters",
      outputLines: "esriNAOutputLineTrueShape",
      restrictionAttributeNames: restrictions,
      impedanceAttributeName: impedance,
      outSR: 4326, //return coords in wgs84 lat/lng, not default of map!!
      directionsLanguage: language,
      token: this.token ? this.token : '',
      f: "json"
    },
    dataType: "jsonp",
    type: "get",
    success: function(results) {
      if(results.routes) {
        var mps = [], cps = [], feat, path, dir, point, i, j, k;
        //first get all the points to draw the route
        for(i = 0; i < results.routes.features.length; i++) {
          feat = results.routes.features[i];
          for(j = 0; j < feat.geometry.paths.length; j++) {
            path = feat.geometry.paths[j];
            for(k = 0; k < path.length; k++) {
              var pt = path[k], prev = path[k-1];
              //ignore duplicate points
              if(prev && prev[0] == pt[0] && prev[1] == pt[1]) continue;
              mps.push(new rwgps.TrackPoint({point: {lat: pt[1], lng: pt[0]}}));
            }
          }
        }

        //now get all the direction points and match them to their corresponding map point.
        //since arcgis doesn't tell us where along the path the direction is, we have to
        //guess.  Even worse is their compression algorithm for storing points is lossy,
        //so we lose between 2-5 meters of accuracy...
        var eps = 0.00003;
        var lastK = 0;
        for(i = 0; i < results.directions.length; i++) {
          dir = results.directions[i];
          for(j = 0; j < dir.features.length; j++) {
            var closestDist = 999999;
            var closestIdx;
            feat = dir.features[j];
            point = self.parseCompressedGeometry(feat.compressedGeometry)[0];
            //trace("\t" + feat.attributes.text)
            for(k = lastK; k < mps.length; k++) {
              var dist = rwgps.Router.euclideanDistance(mps[k].point, point);
              //trace([dist, closestDist, closestIdx])
              if(dist < closestDist) {
                closestDist = dist;
                closestIdx = k;
                if(dist < eps) break;
              }
            }
            //ignore start/end instructions as well as any that don't match our epsilon
            if(closestDist < eps && closestIdx > 0 && closestIdx < (mps.length-1)) {
              //trace([dist, closestDist, closestIdx])
              var notes = self.cleanupNotes(feat.attributes.text);
              cps.push(new rwgps.CoursePoint({
                point: point,
                trackPoint: mps[closestIdx],
                notes: notes,
                type: self.extractTypeFromNotes(notes),
                duration: feat.attributes.time
              }));
              //trace([k, mps.length, feat.attributes.text, cps[cps.length-1]])
              lastK = closestIdx;
            } else {
              //trace(["didn't find any matches", closestDist, closestIdx, mps.length, feat.attributes.text]);
            }
          }
        }

        success(mps, cps, opts, lineColor)
      } else {
        error("No routes found");
      }
    },
    error: function(err) { error(err); }
  });
  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B'
  trackEvent('Google Maps', `Direction Request (${group})`, this.opts.type);
  trackEvent('Google Maps', 'Direction Request', this.opts.type);
}
rwgps.Router.ArcGIS.prototype.parseCompressedGeometry = function (str) {
  var a = 0, b = 0, points = [], x, y;
  //var parsedStr = str.replace(/(\+)|(\-)/g," $&").split(" ");
  var parsedStr = str.replace(/(\+[0-9])*(\+)/, '$2').replace(/\|.*/, '').replace(/(\+)|(\-)/g," $&").split(" ");
  var coef = parseInt(parsedStr[1], 32);

  for(var j=2, jl=parsedStr.length; j < jl; j+=2) {
    a = (x = (parseInt(parsedStr[j], 32) + a));
    b = (y = (parseInt(parsedStr[j+1], 32) + b));
    points.push({lat: y/coef, lng: x/coef});
  }
  return points;
}

rwgps.Router.Google = function(opts) {
  this.opts = opts;
}
rwgps.Router.Google.prototype = new rwgps.Router();
rwgps.Router.Google.prototype.getDirections = function(points, opts, lineColor, success, error) {
  const googleLatLngs = points.map(x => new google.maps.LatLng(x.lat, x.lng))
  var self = this;
  var args = arguments;
  var service = new google.maps.DirectionsService();
  var mode = null;
  var waypoints = (googleLatLngs.length > 2 ? googleLatLngs.slice(1, googleLatLngs.length-1) : []);
  if(opts.cyclingMode()) {
    mode = google.maps.DirectionsTravelMode.BICYCLING;
  } else if(opts.walkingMode()) {
    mode = google.maps.DirectionsTravelMode.WALKING;
  } else {
    mode = google.maps.DirectionsTravelMode.DRIVING;
  }
  var request = {
    origin: googleLatLngs[0],
    destination: googleLatLngs[googleLatLngs.length-1],
    waypoints: _.map(waypoints, function(pt) { return {location: pt, stopover: false} }),
    provideRouteAlternatives: false,
    unitSystem: google.maps.DirectionsUnitSystem.METRIC,
    travelMode: mode,
    avoidHighways: opts.avoidHighways()
  };

  function callback(result, status) {
    if(status == google.maps.DirectionsStatus.OK) {
      var mps = [], cps = [];
      for(var i = 0; i < result.routes.length; i++) {
        for(var j = 0; j < result.routes[i].legs.length; j++) {
          for(var k = 0; k < result.routes[i].legs[j].steps.length; k++) {
            var step = result.routes[i].legs[j].steps[k];
            //there is a step for each drivign direction.  the step
            //has latlng points leading up to the instruction.  We
            //also might want to toss this direction if it's superfluous
            if(mps.length > 0) { //if the first point is a direction...we can toss it
              //mps.push(new rwgps.TrackPoint({point: step.start_point}));
              var notes = self.cleanupNotes(step.instructions);
              cps.push(new rwgps.CoursePoint({
                point: {lat: step.path[0].lat(), lng: step.path[0].lng()},
                trackPoint: mps[mps.length-1],
                notes: notes,
                type: self.extractTypeFromNotes(notes),
                duration: step.duration.value
              }));
            }
            for(var l = 0; l < step.path.length; l++) {
              var prev = step.path[l-1], pt = step.path[l];
              //skip duplicate points
              if(prev && prev.lat() == pt.lat() && prev.lng() == pt.lng()) continue;
              mps.push(new rwgps.TrackPoint({point: {lat: pt.lat(), lng: pt.lng()}}));
            }
          }
        }
      }

      // temporarily cast surface type to paved because rendering it as unknown for a few hundred ms causes an unsightly flash
      mps.forEach(tp => {
        tp.ghSurface = tp.surface = 0 // paved
        tp.roadClass = 2 // primary
      })
      if (!window.Routes.activeMap.draggingMarker) {
        // if the user is actively dragging, don't fetch surfaces. the drag end handler will fetch surfaces when they finish dragging.
        window.Routes.activeMap.injectSurfaces(mps, error)
      }
      // call success immediately without surface type (or elevation) so the polyline is rendered as soon as it's available
      success(mps, cps, opts, lineColor)
    } else {
      var retry = error(status);
      if(retry) {
        setTimeout(function() {
          self.getDirections.apply(self, args);
        }, 3000);
      }
    }
  }
  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B'
  trackEvent('Google Maps', `Direction Request (${group})`, this.opts.type);
  trackEvent('Google Maps', 'Direction Request', this.opts.type);
  service.route(request, callback);
}

rwgps.Router.RWGPSCombined = function(opts) {
  this.opts = opts;
  this.language = opts.language;
  this.url = "/mrp_route";
}
rwgps.Router.RWGPSCombined.prototype = new rwgps.Router();
rwgps.Router.RWGPSCombined.prototype.extractType = function(sign) {
  const mappings = {
    '-98': 'Uturn',//u turn unknown
    '-8': 'Uturn',//u turn left
    '-7': 'Slight Left',//keep left
    '-3': 'Sharp Left',//sharp left
    '-2': 'Left',
    '-1': 'Slight Left',//slight left
    '0': 'Straight',//continue
    '1': 'Slight Right',//slight right
    '2': 'Right',//right
    '3': 'Sharp Right',//sharp right
    '4': 'Generic',//finish
    '5': 'Generic',//midpoint/via reached
    '6': 'Straight',//roundabout
    '7': 'Slight Right',//keep right
    '8': 'Uturn'//u turn
  }

  return mappings[sign] || 'Generic'
}

rwgps.Router.RWGPSCombined.prototype.getDirections = function(points, opts, lineColor, success, error) {
  var self = this, mode, weighting;
  var url = self.url;

  if(opts.cyclingMode()) {
    mode = "rwgpsbike";
    weighting = "rwgps";
  } else if(opts.cyclingExperimentMode()) {
    mode = "rwgpsbike";
    weighting = "rwgps";
    url = "https://directions-test.ridewithgps.com/route";
  } else if(opts.walkingMode()) {
    mode = "foot";
    weighting = "fastest";
  } else {
    mode = "car";
    weighting = "fastest";
  }
  var params = "?vehicle="+mode+"&weighting="+weighting;
  params += "&points="
  points.map(p => {
    params += `${p.lat},${p.lng};`;
  })
  params += "&locale="+window.navigator.language;
  params += "&type=json";
  params += "&point_attrs=surface,re"

  $.ajaxSettings.stopCSRF = true;
  $.ajax({
    url: url + params,
    dataType: "json",
    type: "get",
    success: function(data) {
      if(data.segments) {
        if(data.segments.length == 0) {
          error("No route found");
          return;
        }

        var i, j, k = 0, mps = [], cps = [];
        for(i = 0; i < data.segments.length; i++) {
          var path = data.segments[i];
          var decoded = self.decodePath(path.points);
          for(j = 0; j < decoded.length; j++) {
            var pt = decoded[j];
            mps.push(new rwgps.TrackPoint({
              point: {lat: pt[0], lng: pt[1]},
              ghSurface: pt[2],
              roadClass: pt[3],
              surface: rwgps.TrackPoint.inferSurface(pt[2], pt[3], pt[0], pt[1]),
              roadEnv: pt[4]
            }));
          }

          for(j = 0; j < path.instructions.length; j++) {
            var inst = path.instructions[j];
            var mp = mps[k + inst.i]
            cps.push(new rwgps.CoursePoint({
              point: mp.point,
              trackPoint: mp,
              notes: inst.n,
              type: inst.t
            }));
          }
          k = mps.length
        }

        if(mps.length > 0)
          success(mps, cps, opts, lineColor);
        else
          error("No route found");
      } else {
        error("No route found");
      }
    },
    error: function(obj, status) {
      error(status);
    }
  });
  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B'
  trackEvent('Google Maps', `Direction Request (${group})`, this.opts.type);
  trackEvent('Google Maps', 'Direction Request', this.opts.type);
}



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/directions.js